import { memo } from 'react';
import { MiscScreen } from '@bonanza-social/navigation';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectIsNewLoyalty } from '../state/status/status.slice';

function StatusInfoScreen() {
  const isNewLoyalty = useSelector(selectIsNewLoyalty);

  return <MiscScreen path={`/status?isNewLoyalty=${isNewLoyalty}`} />;
}

export default memo(StatusInfoScreen);
